import React, { useState } from "react";
import { Image as ImageIcon, X } from "lucide-react";
import { api } from "@/lib/api";

// Shown when the supplier has no logo and no product photo anywhere — buyers currently see "No image" on their cards.
export default function MissingImagePrompt({ user, listings, products, onUpload }) {
  const key = `as_image_prompt_dismissed_${user?.id || "anon"}`;
  const [dismissed, setDismissed] = useState(() => localStorage.getItem(key) === "1" || Boolean(user?.image_prompt_dismissed_at));
  if (dismissed || !listings?.length) return null;
  const hasLogo = Boolean(user?.logo_url || user?.company_logo_url) || listings.some((l) => l.logo_url);
  const hasPhoto = listings.some((l) => l.image_url || (l.gallery || []).length) || (products || []).some((p) => p.image_url);
  if (hasLogo || hasPhoto) return null;
  const dismiss = () => {
    localStorage.setItem(key, "1"); setDismissed(true);
    api.post("/supplier/image-prompt/dismiss").catch(() => {});
  };
  return (
    <div className="mb-4 bg-[#FFF8E6] border-l-4 border-[#B8860B] px-5 py-3 flex items-start gap-3" data-testid="missing-image-prompt">
      <ImageIcon className="w-5 h-5 text-[#B8860B] mt-0.5 flex-shrink-0" />
      <div className="flex-1">
        <div className="tracking-overline text-[11px] text-[#8A6400]">Add your logo or a product photo</div>
        <div className="text-sm text-[#11211A] mt-0.5">Your listing currently shows "No image" to buyers. Listings with a logo or photo get noticeably more enquiries — it takes under a minute.</div>
        <button type="button" onClick={onUpload} className="mt-2 text-[10px] uppercase tracking-widest font-semibold text-[#264839] underline underline-offset-2" data-testid="missing-image-prompt-upload">Upload now →</button>
      </div>
      <button type="button" onClick={dismiss} className="text-[#7D8C85] hover:text-[#11211A]" title="Dismiss" aria-label="Dismiss" data-testid="missing-image-prompt-dismiss"><X className="w-4 h-4" /></button>
    </div>
  );
}
